import React from "react";
import { Button, Typography, Row, Col } from "antd";

import { ContentOnly as Layout } from "../../Layout";

import "./ErrorBoundry.scss";
import { AppPathNames } from "@/constants/AppPathNames";

const { Title, Text } = Typography;

class ErrorBoundry extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null, hasError: false };

    this.GoBack = this.GoBack.bind(this);
  }

  static getDerivedSatetFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error);
    console.error(errorInfo);

    this.setState({
      error,
      errorInfo,
      hasError: true,
    });
  }

  GoBack() {
    window.location.href = AppPathNames.root;
  }

  render() {
    if (this.state.hasError)
      return (
        <Layout>
          <Row align="middle" justify="center">
            <Col>
              <div>
                <div className="error-boundry">
                  <Title level={1} className="error-boundry__header">
                    {this.props.msg ? this.props.msg : "Something went wrong."}
                  </Title>

                  <Text className="error-boundry__body">Please refresh your page or go back.</Text>

                  <Button className="error-boundry__btn" type="primary" onClick={this.GoBack}>
                    Go back
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Layout>
      );

    return this.props.children;
  }
}

export default ErrorBoundry;
